import React from 'react';
import { motion } from 'framer-motion';

const UP_IMAGE = "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/6deeebd83f858de340a5ce9e887d37fd.png";
const DOWN_IMAGE = "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/7e2e8682e34959a5d551fff81287c5b4.png";

export default function SideNav({ current, total, onPrev, onNext }) {
  return (
    <div className="fixed right-5 top-1/2 -translate-y-1/2 z-50 flex flex-col items-center gap-4">
      {/* Up Arrow (Cowboy) */}
      <motion.button
        onClick={onPrev}
        disabled={current === 0}
        whileHover={{ scale: 1.15, y: -3 }}
        whileTap={{ scale: 0.92 }}
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.4 }}
        className="group relative flex items-center justify-center h-14 w-14 rounded-2xl border-2 border-[#f59e0b]/40 bg-[#181818]/90 backdrop-blur-xl shadow-2xl shadow-[#f59e0b]/10 disabled:opacity-20 disabled:cursor-not-allowed transition-all duration-300 hover:border-[#f59e0b] hover:shadow-[#f59e0b]/30 overflow-hidden"
        style={{ boxShadow: current === 0 ? 'none' : '0 0 24px rgba(245,158,11,0.15)' }}
      >
        <div className="absolute inset-0 rounded-2xl bg-[#f59e0b]/0 group-hover:bg-[#f59e0b]/10 transition-all duration-300 pointer-events-none" />
        <img 
          src={UP_IMAGE} 
          alt="Up" 
          className="h-8 w-8 object-contain relative z-10 drop-shadow-md opacity-90 group-hover:opacity-100 transition-opacity" 
        />
      </motion.button>

      {/* Slide counter */}
      <div className="flex flex-col items-center gap-1.5">
        {Array.from({ length: total }).map((_, i) => (
          <motion.div
            key={i}
            animate={{
              height: i === current ? 20 : 4,
              backgroundColor: i === current ? '#f59e0b' : 'rgba(255,255,255,0.15)',
            }}
            transition={{ duration: 0.3 }}
            className="w-1 rounded-full"
          />
        ))}
      </div>

      {/* Down Arrow (Cacti) */}
      <motion.button
        onClick={onNext}
        disabled={current === total - 1}
        whileHover={{ scale: 1.15, y: 3 }}
        whileTap={{ scale: 0.92 }}
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.4, delay: 0.1 }}
        className="group relative flex items-center justify-center h-14 w-14 rounded-2xl border-2 border-[#f59e0b]/40 bg-[#181818]/90 backdrop-blur-xl shadow-2xl shadow-[#f59e0b]/10 disabled:opacity-20 disabled:cursor-not-allowed transition-all duration-300 hover:border-[#f59e0b] hover:shadow-[#f59e0b]/30 overflow-hidden"
        style={{ boxShadow: current === total - 1 ? 'none' : '0 0 24px rgba(245,158,11,0.15)' }}
      >
        <div className="absolute inset-0 rounded-2xl bg-[#f59e0b]/0 group-hover:bg-[#f59e0b]/10 transition-all duration-300 pointer-events-none" />
        <img 
          src={DOWN_IMAGE} 
          alt="Down" 
          className="h-8 w-8 object-contain relative z-10 drop-shadow-md opacity-90 group-hover:opacity-100 transition-opacity" 
        />
      </motion.button>
    </div>
  );
}